export class HubVisitorPromotionImage {
  public link: string;
  public image: string;
  public isTop: Boolean;
  public isDisabled: Boolean;
}


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/models/hub/hub.visitor.promotion.image.ts